import { ReactElement } from "react";
import { ListTableColumn, renderEnumValue } from "sprint-common-web";

import { EncodeSpecificationType } from "../../admin/encode-specification/context/EncodeSpecificationItem";

export const renderEncodeSpecificationType = <T>(
    item?: T,
    _index?: number,
    column?: ListTableColumn<T>
): ReactElement | null => {
    return renderEnumValue(EncodeSpecificationType, item, _index, column);
};

export const mapToEncodeSpecificationType = (type: number | string): EncodeSpecificationType => {
    const encodeSpecificationType = Number(type);

    if (!EncodeSpecificationType[encodeSpecificationType]) {
        throw new Error("Incorrect encode specification type");
    }

    return encodeSpecificationType;
};
